import styled from '@emotion/styled';

export default styled.div`
  width: ${({ fullWidth = true }) => (fullWidth ? '100%' : '350px')};
`;
